import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Cable, Shield, Radio, Fingerprint, Layers, PhoneCall, Webhook, Globe } from "lucide-react";
import { Link } from "react-router-dom";

const sections = [
  {
    title: "PJSIP",
    description: "Configure trunk contexts (endpoints), transports, authentication, AORs, and identifies",
    items: [
      { label: "Trunk Contexts", path: "/config/contexts", icon: Layers },
      { label: "Transports", path: "/config/transports", icon: Cable },
      { label: "Auths", path: "/config/auths", icon: Shield },
      { label: "AORs", path: "/config/aors", icon: Radio },
      { label: "Identifies", path: "/config/identifies", icon: Fingerprint },
    ],
  },
  {
    title: "Dialplan",
    description: "Configure dialplan extensions with typed actions linked to contexts",
    items: [
      { label: "Extensions", path: "/config/extensions", icon: PhoneCall },
    ],
  },
  {
    title: "Applications",
    description: "Set up ARI Stasis apps and WebSocket client connections",
    items: [
      { label: "ARI Apps", path: "/config/ari-apps", icon: Webhook },
      { label: "WebSocket", path: "/config/websocket-endpoints", icon: Globe },
    ],
  },
];

export default function ConfigIndexPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Asterisk Configuration</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage your Asterisk PBX configuration through the resources below. Use the sidebar to navigate or pick a section.
        </p>
      </div>
      <div className="space-y-6">
        {sections.map((section) => (
          <div key={section.title}>
            <h2 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3">
              {section.title}
            </h2>
            <p className="text-sm text-muted-foreground mb-3">{section.description}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
              {section.items.map((item) => (
                <Link key={item.path} to={item.path}>
                  <Card className="hover:border-primary/50 transition-colors cursor-pointer h-full">
                    <CardHeader className="p-4 pb-2">
                      <CardTitle className="text-sm flex items-center gap-2">
                        <item.icon size={16} className="text-primary" />
                        {item.label}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="p-4 pt-0">
                      <CardDescription className="text-xs">
                        Manage {item.label.toLowerCase()}
                      </CardDescription>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}